import { render } from "./DaftarDokumen.vue?vue&type=template&id=59de7a96"
import script from "./DaftarDokumen.vue?vue&type=script&lang=js"
export * from "./DaftarDokumen.vue?vue&type=script&lang=js"

import "./DaftarDokumen.vue?vue&type=style&index=0&id=59de7a96&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__